import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {AgGridModule} from '@ag-grid-community/angular';
import {SharedModule} from '../shared.modules';

import {GridEventMultiSelectComponent} from './grid-event-multi-select/grid-event-multi-select.component';

const GRID_COMPONENT = [
    GridEventMultiSelectComponent
];

const CUSTOM_CELL = [];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        AgGridModule,
        ...GRID_COMPONENT, ...CUSTOM_CELL
    ],
    exports: [
        ...GRID_COMPONENT
    ]
})
export class CustomAgGridModule {
}
